import { Component } from '@angular/core';
import { AppVersion } from 'ionic-native';

@Component({
  selector: 'about-page',
  templateUrl: 'about.html'
})
export class AboutPage {
  appName: string;
  versionNumber: string;
  constructor() { }
  ngAfterViewInit() {
    try {
      // AppVersion.getAppName().then((res) => {
      //   this.appName = res;
      // });
      AppVersion.getVersionNumber().then((res) => {
        setTimeout(() => { this.versionNumber = res; });
      });
    } catch (e) { }
  }
}



// WEBPACK FOOTER //
// ./src/pages/about/about.ts